import { NewsContentType } from '@/types/enum';

export default {
  id: '20210508', //  模块 id
  title: '4水年华 初心犹在 | “表白叮咚”留言板活动入选揭晓啦！', // 标题
  origin: '', // 新闻来源
  editor: '', // 编辑者
  content: [
    {
      type: NewsContentType.Text,
      text:
        '在4月下旬，我们通过“叮咚留言板，表白送惊喜”线上活动，征集了一波小伙伴们对叮咚买菜的深情表白，小编深深感受到来自不同岗位的小伙伴们对叮咚的爱和成长。在叮咚四周年来临之时，来看看他们都有什么话想说吧！',
    },
    {
      type: NewsContentType.EmptyLine,
    },
    {
      type: NewsContentType.Text,
      text: '@浙江事业部 陈龙',
    },
    {
      type: NewsContentType.Text,
      text:
        '叮咚四周年生日，我也入职18个月，深切的感受到企业的生长和组织的发展，每天都会被大家奋斗精神鼓舞和包裹着。办公室的灯永远是这栋楼里最晚熄灭的，同学们会为商品、服务这些内容头脑风暴、激烈讨论，都有极强的责任感和荣誉感。祝叮咚未来越来越好，建设比见识更重要！',
    },
    {
      type: NewsContentType.EmptyLine,
    },
    {
      type: NewsContentType.Text,
      text: '@上海事业部 欧阳阳阳',
    },
    {
      type: NewsContentType.Text,
      text:
        '来到叮咚买菜并不久,但亲切随和的领导和同事们，让我感觉这里并不陌生。我们站年轻人居多,充满着蓬勃朝气，大家工作时有干劲、有冲劲，这些氛围都吸引着我,想快快融入进去,认真工作、快乐生活。希望叮咚越来越好，用户越来越多！',
    },
    {
      type: NewsContentType.EmptyLine,
    },
    {
      type: NewsContentType.Text,
      text: '@供应链算法部 Randy',
    },
    {
      type: NewsContentType.Text,
      text:
        '感谢叮咚为北方带来了活虾海产，身为一个南方姑娘的丈夫，深知在北京要海鲜水产触手可得的难度和重要性。叮咚的价值在这一刻凸显了，自来水哲学也绝不是空口白话。',
    },
    {
      type: NewsContentType.EmptyLine,
    },
    {
      type: NewsContentType.Text,
      text: '@产品技术中心 雷黎',
    },
    {
      type: NewsContentType.Text,
      text:
        '宝宝一周岁生日的前一天，我入职叮咚，现在已经7个月多了，宝宝也12+7个多月了。我在叮咚的成长和宝宝的成长同步进行中。我想最好的爱和教育，不仅仅是付出和奉献，还应该是你成长的陪伴和永远的支持。',
    },
    {
      type: NewsContentType.EmptyLine,
    },
    {
      type: NewsContentType.Text,
      text: '@成都事业部 梁钰龙',
    },
    {
      type: NewsContentType.Text,
      text:
        '留学回国，毫不犹豫选择叮咚，从配送做起。第一次参加叮咚铁军军训营，留下了特别深刻的印象，我与组员一起合作，成功拿下团队和个人殊荣。作为生鲜电商拓荒者，希望叮咚秉持美好愿景，一路披荆斩棘，一路向前，我将与叮咚一起成长。',
    },
    {
      type: NewsContentType.EmptyLine,
    },
    {
      type: NewsContentType.Text,
      text: '@用户生长部 王昌冬',
    },
    {
      type: NewsContentType.Text,
      text:
        '初识叮咚，你是地铁里的广告语；再见叮咚，你是拉“心”人的挑灯夜战；深入叮咚，你是留给万千用户方便的那一抹叮咚绿！下一个四年，期待更加美好的叮咚，期待遇见更加相惜的叮咚人，期待叮咚敲响万千用户的家门！',
    },
    {
      type: NewsContentType.EmptyLine,
    },
    {
      type: NewsContentType.Text,
      text: '@江苏事业部 张恩栋',
    },
    {
      type: NewsContentType.Text,
      text:
        '初到叮咚我是一个懵懂的少年，经过两年的锤炼，现在已经是身披绿甲的斗士。经过企业文化的熏陶，肩上多了使命与责任，心里多了要性与担当。衷心感谢叮咚对我的培养。',
    },
    {
      type: NewsContentType.EmptyLine,
    },
    {
      type: NewsContentType.Text,
      text: '@北京事业部 马各燕',
    },
    {
      type: NewsContentType.Text,
      text:
        '我以前是干餐饮行业，去年年初因为疫情让我失业在家。那时的我，有为了结婚欠下的外债，还有每月两千多房贷。也是在去年，叮咚买菜来到首都北京，我就立马决定去应聘。现在到叮咚也已经一年了，感谢叮咚买菜让我还完了外债，现在每个月还房贷轻轻松松，希望叮咚买菜越来越好！',
    },
    {
      type: NewsContentType.EmptyLine,
    },
    {
      type: NewsContentType.Text,
      text: '@生命之战之上海特区 陈华群',
    },
    {
      type: NewsContentType.Text,
      text:
        '光阴似箭，一晃来叮咚瑞盛站半年了。从只想做一名分拣到想做一个仓管，乃至以后发展成站长甚至更高职位，是我对叮咚的向往。把叮咚当成自己的家，我希望我的家会越来越好，获得越来越多用户的认可和喜爱。接下来的日子我和叮咚一起成长！',
    },
    {
      type: NewsContentType.EmptyLine,
    },
    {
      type: NewsContentType.Text,
      text: '@江苏事业部 支海威',
    },
    {
      type: NewsContentType.Text,
      text:
        '不知不觉中，入职叮咚已经两年时光。工作地点从上海嘉定到苏州，再到上海浦东，最后到现在的马鞍山；工作岗位从分拣员到理货员、数据员、仓管员到现在的站务。虽然经历过这么多的转变，也经历过各种挫折，但初心不变，目标只有一个，那就是希望自己在叮咚能越来越好。同时，也希望叮咚也能越来越好，争取能早日覆盖到我的家乡！',
    },
    {
      type: NewsContentType.EmptyLine,
    },
    {
      type: NewsContentType.Text,
      text: '@广东事业部 胡冬',
    },
    {
      type: NewsContentType.Text,
      text:
        '无论天晴下雨，不管送单过程有多辛苦，当把订单送到用户手中，看到用户对我们的信任和满意的笑容瞬间就觉得一切都值了。我们尽力的把服务做到极致，也会帮助用户做一些力所能及的事情，比如帮用户扔垃圾、带东西。在站里我是一个努力的小哥，荣幸大家都叫我“哥王”，未来一起加油，叮咚加油！',
    },
    {
      type: NewsContentType.EmptyLine,
    },
    {
      type: NewsContentType.Text,
      text: '@叮咚大学 马传行',
    },
    {
      type: NewsContentType.Text,
      text:
        '写下这段话的时候，正好是我在叮咚的521天。从张江高科到光大安石，从上海事业部到叮咚大学，从三周年到四周年，我有幸见证了叮咚太多的改变。叮咚的每一位奋斗者，都是汇聚太阳高举火把的星星点点，双眼是日夜的分界线，在夜空里找北斗星的脸，在昼夜轮转的规律里，陪伴叮咚见证一场成长的冒险，似水流年，初心不变。',
    },
    {
      type: NewsContentType.EmptyLine,
    },
    {
      type: NewsContentType.Text,
      text: '@叮咚小满 黎环',
    },
    {
      type: NewsContentType.Text,
      text:
        '2016年到2021年整整5年，从开始的叮咚小区，到叮咚代买菜，到叮咚买菜，再到现在多业态发展的叮咚，感谢与公司一起成长。希望叮咚在未来的日子里，走向更多供应链源头，真正做到农业产业升级，帮助供需两端减少中间的损耗，成为中国各个城市的基础建设，成为各个产地农产品的销售渠道，帮助千千万万个乡村振兴。',
    },
    {
      type: NewsContentType.EmptyLine,
    },
    {
      type: NewsContentType.Text,
      text: '@人力资源部 杨宝月',
    },
    {
      type: NewsContentType.Text,
      text:
        '从张江高科站到广兰路站，办公楼层越来越多；从上海到江浙、华南、华北和西南，叮咚的红萝卜插遍全国；从买菜到早上好、小满和谷雨，我们服务的对象越来越广。希望叮咚买菜一往如前，开遍全国各地；叮咚铁军一马当先，征战大江南北。',
    },
    {
      type: NewsContentType.EmptyLine,
    },
    {
      type: NewsContentType.Text,
      text: '@运营中心 詹绍芬',
    },
    {
      type: NewsContentType.Text,
      text:
        '加入叮咚买菜的第2218天，我仍然热爱它，且为之自豪。绝不把不好的菜卖给用户是我们不能忘却的初心，希望所有人都能够坚守，Always Day One！',
    },
    {
      type: NewsContentType.EmptyLine,
    },
    {
      type: NewsContentType.Text,
      text:
        '恭喜以上入选小伙伴，小编近期将通过企业微信与你取得联系，为你送上一份保萝小礼物哦~',
    },
  ],
};
